import type {ReactElement} from 'react';
import React from 'react';
import {FadeBackground} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/fade-background/fade-background';
import {FadeDirection} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/fade-background/fade-background.types';
import type {AudioItemFadeBackgroundProps} from './audio-item-fade-background.types';
import {
  FADE_SLIDER_GAP,
  FADE_SLIDER_INTERNAL_PADDING,
  FADE_SLIDER_CONTAINER_RIGHT_PADDING,
  FADE_SLIDER_HANDLE_RADIUS,
  LEFT_PADDING_FOR_FADE_BACKGROUND,
} from './audio-item-fade-background.types';
import styles from './audio-item-fade-background.module.scss';
import {useAppSelector} from '@/hooks';

export function AudioItemFadeBackground({className = '', direction = FadeDirection.LEFT, ...props}: AudioItemFadeBackgroundProps): ReactElement<any> | null {
  const audioData = useAppSelector((state) => {
    return state.posterEditor.posterObject?.audioClips.audioItemsHashMap[props.audioId];
  });
  const audioItem = window.posterEditor?.whiteboard?.audioClips.audioItemsHashMap[props.audioId];

  const fadeData = audioData?.audioPlayer.fade;

  if (!fadeData || !audioData || !audioItem) {
    return null;
  }

  const showFadeBg = (): boolean => {
    if (direction === FadeDirection.LEFT && fadeData.fadeInDuration === 0) {
      return false;
    }

    return !(direction === FadeDirection.RIGHT && fadeData.fadeOutDuration === 0);
  };

  const getWidthForFade = (fade: number): string => {
    const duration = (audioData.audioPlayer.trim.endTime - audioData.audioPlayer.trim.startTime) / audioData.audioPlayer.speed;
    const totalWidthForItem = duration * props.widthPerSecond;
    const totalWidthForFadeSlider = totalWidthForItem / 2 - LEFT_PADDING_FOR_FADE_BACKGROUND - FADE_SLIDER_CONTAINER_RIGHT_PADDING - FADE_SLIDER_GAP - FADE_SLIDER_INTERNAL_PADDING;
    const fadeSliderWidth = (fade * totalWidthForFadeSlider) / audioItem.audioPlayer.getMaxFadeDuration();

    return `${fadeSliderWidth + LEFT_PADDING_FOR_FADE_BACKGROUND + FADE_SLIDER_HANDLE_RADIUS / 2}px`;
  };

  const getWidthFromFade = (): string | undefined => {
    if (direction === FadeDirection.LEFT) {
      return getWidthForFade(fadeData.fadeInDuration);
    }
    return getWidthForFade(fadeData.fadeOutDuration);
  };

  return showFadeBg() ? (
    <div
      style={{
        width: getWidthFromFade(),
      }}
      className={`${className} ${styles.fadeBackgroundWrapper} _full-height ${direction === FadeDirection.LEFT ? styles.left : styles.right}`}
    >
      <FadeBackground direction={direction} />
    </div>
  ) : null;
}
